import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

// image
import img2 from "../../../assets/images/images-2.jpg"
import img3 from "../../../assets/images/images-3.jpg"
import img4 from "../../../assets/images/images-4.jpg"
import img6 from "../../../assets/images/images-6.jpg"

const Images = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Images" pageType="Elements" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Images Responsive
            </h2>
            <div>
              <img
                src={img6}
                className="object-cover w-full md:h-72"
                alt=""
              />
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Images Rounded
            </h2>
            <div>
              <img
                src={img2}
                className="object-cover w-full rounded-md md:h-72"
                alt=""
              />
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Images Circle
            </h2>
            <div>
              <img
                src={img3}
                className="mx-auto rounded-full h-44 w-44"
                alt=""
              />
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Images With Ring
            </h2>
            <div>
              <img
                src={img4}
                className="object-cover w-full rounded ring-offset-4 ring-2 ring-light dark:ring-darkborder md:h-72"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Images;
